import React from "react";
import ExpenseForm from "./ExpenseForm";
import { connect } from 'react-redux';
import { addExpense, startAddExpense } from "../actions/expenses";
import { useNavigate } from 'react-router-dom';

const AddExpensePage = (props) => {

    const navigate=useNavigate();

    return (
        <div className='col-md-9 col-12 offset-md-3 expense-form-page'>

            <h1 className="heading">Add Expense</h1>
            <hr />

            <ExpenseForm
                onSubmit={(expense) => {
                    props.dispatch(startAddExpense(expense));
                    navigate('/');
                }}
             />
        </div>
    );
}
export default connect()(AddExpensePage);